import type { PayloadLink as PayloadLinkType } from '@repo/api-payload';
import { ComponentProps, useMemo } from 'react';
import { NavLink } from 'react-router';
import { useLocalePath } from '~/hooks/useLocalePath';

type NavLinkLinkPayloadProps = {
  className?: string;
  payloadLink: PayloadLinkType;
} & Omit<ComponentProps<typeof NavLink>, 'to'>;

export const NavLinkPayload = ( { children, className, payloadLink, ...linkAttrs }: NavLinkLinkPayloadProps ) => {
  const localePath = useLocalePath();

  const to = useMemo( () => {
    if ( payloadLink.type === 'internal' ) {
      return localePath( payloadLink.link );
    }

    if ( payloadLink.type === 'link' ) {
      return payloadLink.path.startsWith( '/' ) ? localePath ( payloadLink.path ) : payloadLink.path;
    }

    if ( payloadLink.type === 'page' ) {
      return localePath( `/insight/${ payloadLink.page.slug }` )
    }

    return '#';
  }, [ payloadLink, localePath ] )

  return (
    <NavLink
      to={ to }
      target={ payloadLink.openInNewTab ? '_blank' : undefined }
      className={ className }
      { ...linkAttrs }
    >
      { children }
    </NavLink>
  )
}
